import { render } from "./user_dialog.vue?vue&type=template&id=6cfc4d86&ts=true"
import script from "./user_dialog.vue?vue&type=script&lang=ts"
export * from "./user_dialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__